import http from '@/utils/http'

export function getAdventureModeLearningPerformance(params){
    return http.get('/adventure_mode_learning_performance',{params})
}
export function getHomeworkLearningPerformance(params){
    return http.get('/homework_learning_performance',{params})
}

export function getGradeSaleReports(params){
    return http.get('/grade_sale_reports',{params})
}
export function getProgramUseReports(params){
    return http.get('/program_use_reports',{params})
}
export function getPayReports(params){
    return http.get('/pay_reports',{params})
}
export function getUserReport(data){
    return http.post('/user_report',data, {
        responseType: "blob",
    })
}
export function getStudentReport(data){
    return http.post('/student_report',data, {
        responseType: "blob",
    })
}

export function getGradeSaleReport(data){
    return http.post('/grade_sale_report',data, {
        responseType: "blob",
    })
}
export function getHomeworkReport(data){
    return http.post('/homework_report',data, {
        responseType: "blob",
    })
}
export function getPractiseReport(data){
    return http.post('/topic_report',data, {
        responseType: "blob",
    })
}
export function getPromotionCodeReport(data){
    return http.post('/promotion_code_report',data, {
        responseType: "blob",
    })
}